var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master-container"},[_c('div',{staticClass:"txt",attrs:{"id":"netflixSplash","contenteditable":"true"}},[_vm._v(" ZAPERMENU ")])])
}]

export { render, staticRenderFns }